import React from 'react';
import TeacherTable from '../../../components/AdminTable/TeacherTable';
import { useTranslation } from 'react-i18next';

function Teacher() {
  const { t } = useTranslation();
  const header = [
    { head1: t("adminDash.teacher.mentorName"), head2: t("adminDash.student.email"), head3: t("adminDash.student.phone"), head4: t("adminDash.teacher.type"), head5: t("adminDash.common.status"), head6: t("adminDash.teacher.visibility"), head7: t("adminDash.common.delete")}
  ];

  return (
    <main>
      <TeacherTable
        heading={t("adminDash.teacher.mentors")}
        SubHeading={""}
        header={header}
      />
    </main>
  );

}

export default Teacher
